module.exports = __webpack_public_path__ + "static/07-801d1bee5eb129218123d4b68bc056ff.png";